import { HDSFlag } from '@here/hds-react-components'
import React from 'react'

interface TransportModeFlagProps {
  icon: string
  children?: React.ReactNode
  bgColor: string
  color: string
}

export default function TransportModeFlag({
  icon,
  bgColor,
  color,
  children,
}: TransportModeFlagProps): JSX.Element {
  return (
    <HDSFlag
      variant="custom"
      size="medium"
      icon={icon}
      iconCategory="travel-transport-tracking"
      style={
        {
          '--hds-flag-custom-accent-color': bgColor,
          '--hds-flag-custom-font-color': color,
          '--hds-icon-color': color,
        } as React.CSSProperties
      }
    >
      {children}
    </HDSFlag>
  )
}
